module.exports = __webpack_public_path__ + "static/media/competitor-lens.c40a9307.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/competitor-lens.png
// module id = 3432
// module chunks = 0